export default __webpack_public_path__ + "static/media/blog-img124.a020d42e.jpg";